import { render, staticRenderFns } from "./login-header.vue?vue&type=template&id=6dca6ca2&scoped=true"
import script from "./login-header.vue?vue&type=script&lang=js"
export * from "./login-header.vue?vue&type=script&lang=js"
import style0 from "./login-header.vue?vue&type=style&index=0&id=6dca6ca2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dca6ca2",
  null
  
)

export default component.exports